// IE 2026 10 29 / ODOO-5800 (ie-dm7 #114865: «ще N документів» — догрузка cell_docs_more)
// Блок DOCUMENTS формы ячейки: хвост «+22» (элемент docs паспорта с id 'register:<ветка>:more' у регистра или 'docs:more' у среза по id) становится кликабельным.
// Контракт бэка (PR #605): хвост — {id, title, clickable: true, qty?, more: {n, qty?, branch: 'ukr'|'cis'|'ids', offset, total, limit: 20, show_all: bool (остаток ≤ 200),
// hint: 'of {total}', keys | ids}}; тексты уже на языке пользователя. Клик — метод виджета отчёта cell_docs_more, params = объект more целиком (+ limit, либо show_all: true);
// ответ {command: 'updateDoc', cell_docs_more: {items: [элементы формата docs], more: хвост | null, branch, offset, limit, total}} либо {state: 'off' | 'bad params' | 'no source' |
// 'error: …'}. items встают на место хвоста, новый more — новым хвостом. Ответ несёт command updateDoc, но он нужен только форме (как cell_passport): cellDocsMore_send снимает
// команду, и стор запись отчёта не трогает, а reportCellFormClose не закрывает форму. Нет more / clickable (флаг бэка not-cell_docs_more, прежний бэк) — хвост как раньше.
// Чистые функции без DOM — tests/unit/cellDocsMore.test.mjs
import { t } from '@/i18n'

export const CELL_DOCS_MORE_METHOD = 'cell_docs_more'
export const CELL_DOCS_MORE_LIMIT = 20
export const CELL_DOCS_VISIBLE = 12   // сколько документов блока видно без догрузки (Dropdown: прежнее cell_docs.slice(0, 12))

const isObj = (x) => !!(x && typeof x === 'object' && !Array.isArray(x))
const str = (v) => (v === undefined || v === null) ? '' : String(v).trim()

// more кликабельного хвоста документа (clickable: true и объект more) либо null — хвост без more / clickable остаётся прежним
export function cellDocsMore_tail(d) {
    return (d && d.clickable === true && isObj(d.more)) ? d.more : null
}

// размер порции кнопки «ще N»: limit хвоста (по умолчанию 20); остаток меньше порции — отдельной кнопки нет, кликабелен сам хвост (0)
export function cellDocsMore_chunk(more) {
    if (!isObj(more)) return 0
    const lim = +more.limit > 0 ? Math.floor(+more.limit) : CELL_DOCS_MORE_LIMIT
    const n = +more.n
    return (isFinite(n) && n > 0) ? Math.min(Math.floor(n), lim) : 0   // IE 2026 10 29 / ODOO-5800 (проба p089e: остаток меньше порции — тоже кнопка «{n} more», не только кликабельный текст хвоста)
}

// кнопка «усі» — бэк разрешил show_all (остаток ≤ 200) и есть отдельная кнопка порции
export function cellDocsMore_showAll(more) {
    return isObj(more) && more.show_all === true && +more.n > cellDocsMore_chunk(more)   // IE 2026 10 29 / ODOO-5800 (проба p089e: остаток меньше порции — тоже кнопка «{n} more», не только кликабельный текст хвоста): «all» — только когда остаток больше порции
}

// IE 2026 10 29 / ODOO-5800 (ie-dm7 r62 #115629: D2: текст хвоста «ще N документів» — кнопка): клик по тексту = «показать все N» (обработчик «all»), если бэк разрешил show_all (остаток ≤ 200);
// иначе — следующая порция (обработчик «N more»): всё сразу бэк не отдаёт
export function cellDocsMore_titleAll(more) {
    return isObj(more) && more.show_all === true && +more.n > 0
}

// params запроса: объект more целиком (+ limit) либо (+ show_all: true); more не меняется
export function cellDocsMore_params(more, opt) {
    if (!isObj(more)) return null
    const all = !!(opt && opt.all)
    if (all) return { ...more, show_all: true }
    const lim = (opt && +opt.limit > 0) ? Math.floor(+opt.limit) : (+more.limit > 0 ? Math.floor(+more.limit) : CELL_DOCS_MORE_LIMIT)
    return { ...more, limit: lim, show_all: false }   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114865, проба p089d: «N more» слал show_all из хвоста BE — приходил весь остаток)
}

// элемент docs в формате формы (как разбор cell_passport.docs в AttrGrid.cellPassport_load); T — названия записей отчёта (doc_links.titles)
export function cellDocsMore_item(d, T) {
    const x = isObj(d) ? d : {}
    const id = str(x.id)
    const q = x.qty != null && isFinite(+x.qty) ? +x.qty : null
    return { id, title: (x.title && x.title !== x.id) ? x.title : ((T && T[id]) || id), kind: x.kind || null, status: x.status || null, link: x.link || null,
        qty: q, status_raw: x.status_raw ? String(x.status_raw) : '', hint: x.hint ? String(x.hint) : '', nodoc: x.nodoc || null, ...cellDocsMore_extra(x) }
}

// поля кликабельного хвоста, которые разбор паспорта переносит в элемент формы
export function cellDocsMore_extra(d) {
    return (d && d.clickable === true && isObj(d.more)) ? { clickable: true, more: d.more } : {}
}

// видимые документы блока: не больше cap обычных документов, кликабельные хвосты — всегда (иначе догрузка недоступна); cap не число — все
// IE 2026 10 29 / ODOO-5800 (ie-dm7 r62 #115629: D3: под хвостом «ще N документів» стояла вторая строка «· +21»): есть кликабельный хвост — отдельного «+N» нет (hidden 0): клик хвоста / кнопок
// раскрывает весь загруженный список (Dropdown.docsExpanded); folded — сколько загруженных документов свёрнуто (для разбора)
export function cellDocsMore_visible(docs, cap) {
    const list = Array.isArray(docs) ? docs : []
    const lim = (typeof cap === 'number' && isFinite(cap)) ? cap : Infinity
    const out = []; let n = 0, tails = 0
    for (const d of list) {
        if (cellDocsMore_tail(d)) { out.push(d); tails++; continue }
        if (n < lim) out.push(d)
        n++
    }
    const folded = Math.max(0, n - lim)
    return { list: out, hidden: tails ? 0 : folded, folded }   // IE 2026 10 29 / ODOO-5800 (ie-dm7 r62 #115629: D3)
}

// разбор ответа cell_docs_more: {ok: true, items, more, …} либо {ok: false, state, text}; state — на верхнем уровне ответа или внутри cell_docs_more;
// items есть — ответ принят, и когда рядом стоит служебный state
export function cellDocsMore_result(answer) {
    const a = isObj(answer) ? answer : {}
    const r = isObj(a.cell_docs_more) ? a.cell_docs_more : null
    if (r && Array.isArray(r.items)) {
        return { ok: true, state: '', text: '', items: r.items, more: isObj(r.more) ? r.more : null, branch: str(r.branch), offset: r.offset, limit: r.limit, total: r.total }
    }
    const state = str(a.state) || str(r && r.state) || 'error: empty answer'
    return { ok: false, state, text: t('Could not load more documents: {state}', { state }), items: [], more: null }
}

// слияние: items на место хвоста tailId, новый more — новым хвостом сразу за ними; повторные id (уже в списке) пропускаются; хвоста в списке нет (форма перечитана) — список как есть
export function cellDocsMore_merge(docs, tailId, res, T) {
    const list = Array.isArray(docs) ? docs : []
    const at = list.findIndex(d => d && d.id === tailId)
    if (at < 0 || !res || !res.ok) return list
    const seen = new Set(list.filter((d, i) => d && i !== at).map(d => d.id))
    const put = []
    for (const raw of res.items || []) {
        const it = cellDocsMore_item(raw, T)
        if (!it.id || seen.has(it.id)) continue
        seen.add(it.id); put.push(it)
    }
    if (isObj(res.more)) {
        const tail = cellDocsMore_item(res.more, T)
        if (tail.id && !seen.has(tail.id) && cellDocsMore_tail(tail)) put.push(tail)
    }
    return [...list.slice(0, at), ...put, ...list.slice(at + 1)]
}

// запрос: executeWidgetMethod отчёта, как cell_passport / fixDates_send. req = {params, done(res)}; форма ушла на другую ячейку, пока шёл запрос (grid._cellPassportSeq) —
// done({ok: false, stale: true}). Ответ нужен только форме: команда снимается (иначе updateDoc отчёта; запись отчёта и закрытие формы reportCellFormClose не затрагиваются)
export function cellDocsMore_send(grid, req) {
    const done = req && typeof req.done === 'function' ? req.done : () => {}
    const store = grid && grid.store
    const fail = (state) => ({ ok: false, state, text: t('Could not load more documents: {state}', { state }), items: [], more: null })
    if (!store || typeof store.executeWidgetMethod !== 'function' || !req || !isObj(req.params)) { done(fail('error: not sent')); return false }
    const seq = grid._cellPassportSeq
    let fin = false
    const finish = (res) => { if (fin) return; fin = true; done(grid._cellPassportSeq !== seq ? { ok: false, stale: true, state: '', text: '', items: [], more: null } : res) }
    store.executeWidgetMethod({ WIDGET: grid.WIDGET }, { command: 'executeWidgetMethod', method: CELL_DOCS_MORE_METHOD, params: req.params,
        record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true,
        _response_callback: (answer) => {
            const res = cellDocsMore_result(answer)
            if (answer && typeof answer === 'object') { answer.command = ''; delete answer.updates; delete answer.record }   // только форме: запись отчёта стор не трогает
            finish(res)
        },
        _onResponse: (a) => { if (a === null) finish(fail('error: no response')) } })
    return true
}
